import { render, staticRenderFns } from "./detail8.vue?vue&type=template&id=57d80962&scoped=true"
import script from "./detail8.vue?vue&type=script&lang=js"
export * from "./detail8.vue?vue&type=script&lang=js"
import style0 from "./detail8.vue?vue&type=style&index=0&id=57d80962&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d80962",
  null
  
)

export default component.exports